import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import MerchantFlowCard from '@nexidigital/merchantflowcard'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import PortalSwitch from '@nexidigital/portalswitch'
import { getFeatureParamsValue } from 'Utility/subscriptionMethods'
import FormField from 'Components/FormField'
import PortalTextBlocked from 'Components/PortalTextBlocked'
import UrlClickToPayField from 'Components/UrlClickToPayField'
import UrlTokenizationFields from 'Components/UrlTokenizationFields'
import TermsCheckBox from '../TermsCheckBox'
import { messages } from './languageModule'
import './ServiceConfig.scss'

const ServiceConfig = ({
  title,
  description,
  disabled,
  active,
  onSwitchChange,
  checked,
  onCheckChange,
  info,
  vas,
  formik
}) => {
  const intl = useIntl()
  const location = useLocation()
  const isActivation = location.pathname.includes('activation') // in case reutilize this component in other contexts, as in Disputeless
  const clickToPayBaseUrl = getFeatureParamsValue(vas, 'ClickToPay', 'ClickToPayBaseUrl')

  const vasName = vas?.feature?.name || ''
  const isTKN = vasName === 'NetworkTokenization'
  const i2C2P = vasName === 'ClickToPay' && !clickToPayBaseUrl

  const Terms = () =>
    onCheckChange && <TermsCheckBox disabled={disabled} checked={checked} onCheckChange={onCheckChange} />

  const InfoFields = () =>
    info?.length > 0 && (
      <div className='serviceConfig_card_info'>
        {info.map((item) => (
          <FormField
            key={item.name}
            readOnly
            readOnlyComponent={<PortalTextBlocked label={item.label} value={item.value || '-'} noPadding />}
          />
        ))}
      </div>
    )
  return isActivation ? (
    <MerchantFlowCard id='enableService' title={title}>
      <div className='serviceConfig_card_content'>
        <div className='serviceConfig_toggle_wrapper'>
          {description && <p className='merchantFlowSubtitle'>{description}</p>}
          <PortalSwitch
            checked={active}
            onChange={onSwitchChange}
            ariaLabel={active ? intl?.formatMessage(messages?.Enabled) : intl?.formatMessage(messages?.Disabled)}
          />
        </div>
        <Terms />
        <InfoFields />
      </div>
    </MerchantFlowCard>
  ) : (
    <MerchantGenericCard>
      <div className='serviceConfig_card_content'>
        <div className='serviceConfig_toggle_wrapper'>
          <div className='serviceConfig_text'>
            <h3 className='genericCardTitle'>{title}</h3>
            {description && <p className='genericCardSubtitle'>{description}</p>}
          </div>
          <PortalSwitch
            checked={active}
            onChange={onSwitchChange}
            ariaLabel={active ? intl?.formatMessage(messages?.Enabled) : intl?.formatMessage(messages?.Disabled)}
            disabled={isTKN && active}
          />
        </div>

        {isTKN && 
          <UrlTokenizationFields
            formik={formik}
            vas={vas}
            active={active}
          />}

        {i2C2P &&
          <UrlClickToPayField
            formik={formik}
            vas={vas}
            active={active}
          />}
        <Terms />
        <InfoFields />   
      </div>
    </MerchantGenericCard>
  )
}

ServiceConfig.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
  onSwitchChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  onCheckChange: PropTypes.func,
  vas: PropTypes.object,
  formik: PropTypes.object,
  info: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string
    })
  )
}

ServiceConfig.defaultProps = {
  // Add here some default propTypes values
  title: '',
  disabled: false,
  active: false,
  onSwitchChange: () => {},
  checked: false,
  vas: {},
  formik: null
}

export default ServiceConfig
